import { Reveal } from "./Reveal";

const STATS = [
  { big: "70%", label: "Recycled or Donated", slug: "recycled" },
  { big: "Same-Day", label: "Service Available", slug: "same-day" },
  { big: "$10K", label: "Make It Right Guarantee", slug: "guarantee" },
  { big: "100%", label: "Locally Owned & Operated", slug: "local" },
];

export const StatsBand = () => (
  <section data-testid="stats-band-section" className="border-b-2 border-gold/30 bg-panel">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px lg:grid-cols-4">
      {STATS.map((s, i) => (
        <div
          key={s.slug}
          data-testid={`stat-${s.slug}`}
          className={`px-6 py-10 text-center md:py-12 ${i % 2 === 1 ? "border-l-2 border-coal" : ""} ${i > 1 ? "border-t-2 border-coal lg:border-t-0" : ""} ${i === 2 ? "lg:border-l-2" : ""} ${i === 3 ? "lg:border-l-2" : ""}`}
        >
          <Reveal delay={i * 0.06}>
            <p className="font-heading text-5xl uppercase leading-none tracking-wide text-gold md:text-6xl">{s.big}</p>
            <p className="mt-3 font-body text-xs font-bold uppercase tracking-[0.2em] text-white/70 md:text-sm">{s.label}</p>
          </Reveal>
        </div>
      ))}
    </div>
  </section>
);
